import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';
const path = '/api/private/companies';

/**
 * 協力会社取得
 */
const show = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}`),
    params: param,
  });
};

/**
 * 協力会社管理者情報取得
 */
const partnerUsers = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/partner_users`),
    params: param,
  });
};

/**
 * 協力会社新規作成
 */
const create = param => {
  return requestWithToken({
    method: 'POST',
    url: path.concat('/company_partner'),
    data: createFormData(param),
  });
};

/**
 * 協力会社情報更新
 */
const update = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/company_partner_update/${id}`),
    data: param,
  });
};

const editCompany = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${id}`),
    data: createFormData(param),
  });
};

const upload_image = (id, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${id}/upload_image`),
    data: param,
  });
};

/**
 * データパラメータ生成
 * @param param {object}
 * @return fd {object}
 */
function createFormData(param) {
  var fd = new FormData();
  _.each(param, (value, index) => {
    if (value && value.type == 'file') {
      fd.append('image', value.files[0]);
    } else {
      if (index === 'password_reset_notice_user') {
        // console.log('value', value);
        fd.append(index, value == undefined ? '' : value);
      } else if (Object.prototype.toString.call(value) === '[object Object]') {
        // eslint-disable-next-line no-unused-vars
        let obj = {};
        _.each(value, (val, col) => {
          fd.append(`${index}[${col}]`, val == undefined ? '' : val);
        });
      } else {
        fd.append(index, value == undefined ? '' : value);
      }
    }
  });

  return fd;
}

/**
 * 類似する会社情報を取得
 */
const similarityCompany = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/similarity_company'),
    params: param,
  });
};

/**
 * JV会社情報を取得
 */
const jvCompanyList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/list_all'),
    params: param,
  });
};

const companyDocuments = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/company_documents/list`),
    params: param,
  });
};

const agentOriginsList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/agent_origins_list'),
    params: param,
  });
};

const agentOriginsApprovalHistories = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/agent_origin_approval_histories'),
    params: param,
  });
};

const getRegisteredCompanies = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/company_users/registered_companies`),
    params: param,
  });
};

const getPartnerCompanyBranchDocuments = (
  id,
  partner_company_branch_id,
  param
) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${id}/partner_company_branches/${partner_company_branch_id}/documents`
    ),
    params: param,
  });
};

const checkDuplicateConstructionPermission = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/check_uniq_common_permission_number`),
    params: param,
  });
};

/**
 * 選択した会社の期限切れ、期限間近についての情報を取得する
 */
const expirations = id => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/expiration`),
    // params: param,
  });
};

/**
 * /api/private/companies/is_ccus_seceded
 */
const getCompaniesCcusSecededFlag = () => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/is_ccus_seceded`,
  });
};

const primeList = () => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/prime_list`),
  });
};

export const CompanyService = {
  create,
  companyDocuments,
  update,
  upload_image,
  similarityCompany,
  jvCompanyList,
  editCompany,
  show,
  partnerUsers,
  agentOriginsList,
  agentOriginsApprovalHistories,
  getRegisteredCompanies,
  getPartnerCompanyBranchDocuments,
  checkDuplicateConstructionPermission,
  expirations,
  getCompaniesCcusSecededFlag,
  primeList,
};
export default CompanyService;



// WEBPACK FOOTER //
// ./src/services/Companies.js